import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import AccountCancelViewWizardStep1 from '../accountCancelViewWizardStep1/accountCancelViewWizardStep1';
import AccountCancelViewWizardStep2 from '../accountCancelViewWizardStep2/accountCancelViewWizardStep2';
import AccountCancelViewWizardStep3 from '../accountCancelViewWizardStep3/accountCancelViewWizardStep3';
import { TEALIUM_EVENTS } from '../../constants/tagging';
import { getTaggingWizard } from '../../helpers/accountCancelViewHelper';

function AccountCancelViewWizard(props) {
    const {
        immAccount,
        immAccountCancel,
        immProfile,
        accountCancelMotiveSelectChanged,
        accountCancelMotiveInputChanged,
        validateStep,
        setVisibleStep,
        setPreLeaveModal,
        setPreLeaveIsPersonalData,
        requestCancelAccount,
        history
    } = props;

    const actions = {
        setVisibleStep: setVisibleStep,
        validateStep: validateStep,
        finish: () => { requestCancelAccount(immAccount)},
        cancel: () => {
            setPreLeaveIsPersonalData(false);
            history.push('/myprofile/accounts');
        },
        setWillCancel: () => { }
    };
    
    return <Wizard
        actions={actions}
        immSteps={immAccountCancel.get('steps')}
        stepsAmount={3}
        visibleStep={immAccountCancel.get('currentStep')}
        wizardClass="deposits-renovations-cancel-account__wizard"
        isTaggingSecondVersion
        tealium={getTaggingWizard(immAccount, immAccountCancel)}
        tealiumEvents={TEALIUM_EVENTS}
    >
        <WizardStep
            position="first"
            cancelButton
        >
            <AccountCancelViewWizardStep1
                immAccountCancel={immAccountCancel}
                accountCancelMotiveSelectChanged={accountCancelMotiveSelectChanged}
                accountCancelMotiveInputChanged={accountCancelMotiveInputChanged}
            />
        </WizardStep>
        <WizardStep
            position="middle"
            cancelButton
        >
            <AccountCancelViewWizardStep2 
                immProfile={immProfile} 
                history={history} 
                setPreLeaveModal={setPreLeaveModal} 
                setPreLeaveIsPersonalData={setPreLeaveIsPersonalData} 
            />
        </WizardStep>
        <WizardStep
            position="last"
            cancelButton
            addLoadingBehaviour
            isLoading={false}
            immFinalButton="cancellation_account-account_cancellation_request_step3_confirmation_send_request_button"
        >
            <AccountCancelViewWizardStep3 immAccountCancel={immAccountCancel} immAccount={immAccount} />
        </WizardStep>
    </Wizard>
}

AccountCancelViewWizard.propTypes = {
    immAccount: PropTypes.instanceOf(Immutable.Map).isRequired,
    immAccountCancel: PropTypes.instanceOf(Immutable.Map).isRequired,
    immProfile: PropTypes.instanceOf(Immutable.Map).isRequired,
    accountCancelMotiveSelectChanged: PropTypes.func.isRequired,
    accountCancelMotiveInputChanged: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    requestCancelAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setPreLeaveModal: PropTypes.func.isRequired,
    setPreLeaveIsPersonalData: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

export default AccountCancelViewWizard;